import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { Question, Ver } from "../question/question";
import { ExtraResult } from "@/lib/model/exambuilder/exam-v2";
import EnglishAssessmentResult from "./english";
import ChineseAssessmentResult from "@/views/paper/components/mandarin/mandarin";
import { TacPsyc } from "@/lib/model/exam/tac-mind";

enum auditTextEnum {
  "待评估",
  "通过",
  "待定",
  "拒绝"
}
export class CvData {
  "健康状况" = "";
  "在集团服务的亲属信息": any[] = [];
  "基本信息": any[] = [];
  "工作经历": any[] = [];
  "重要技能训练记录": any[] = [];
}

//候选人登记字段
export class Param extends Model {
  name = "";
  value = "";
  cascadeValue = "";
  isShow = 0; // 0未定义 1是 2否
  long = false; //是否长句子
  inputType = "";
}
export class BgBuy extends Model {
  afterBuy = 0;
  financialRisk = 0;
  identityInfo = 0;
  productId = 0;
  socialInfo = 0;
}

export class BG extends Model {
  bgCheckStatus = 0;
  errorMessage = "";
  financialRiskStatus = 0;
  identityInfoStatus = 0;
  product = new BgBuy();
  requestId = 0;
  socialInfoStatus = 0;
  status = 0;
  socialInfoErrorLevel: number | null = null;
  financialRiskErrorLevel: number | null = null;
}
//心理结果
export class MindResult extends Model {
  afterHr = 0; //经过hr修改
  depressiveTestResultAdmin = 0;
  depressiveTestResultAi = 0;
  depressiveTestResultChoice = 0;
  depressiveTestResultHr = 0;
  violentTestResultAdmin = 0;
  violentTestResultAi = 0;
  violentTestResultChoice = 0;
  violentTestResultHr = 0;
  //友达光电新字段
  ydgdJsb = 0; //友达光电 精神病
  ydgdCd = 0; //冲动性
  ydgdSh = 0; //说谎性
  ydgdJsbResText = ""; //结果文案
  ydgdCdResText = ""; //结果文案
  ydgdShResText = ""; //结果文案
  //通用字段
  depressive = 0; //抑郁
  depressiveResText = "";
  violent = 0; //暴力
  violentResText = "";
}
class ReplaceCheckResult extends Model {
  result = 0; //0不足 1异常 2正常
  imgList: string[] = [""];
}
class FaceDetectionResult extends Model {
  result = 0; //0不足 1异常 2正常
  imgList: string[] = [""];
  failNumber = ""; // 无人脸图片数
  totalNumber = ""; // 全部图片数
}
export class ErrorInfo extends Model {
  task = ""; //考察项名称
  result = 0; //1异常 其他正常
  resMessage = ""; //结果文案
}
//候选人面试报告数据(主表)
export class Candidate extends Model {
  candidateId = "";
  score = 0; //总分
  auditStatus = 0; //总结果 0未审核 1通过 2待定 3拒绝
  auditText = ""; //总结果-文字
  auditDesc = ""; //评价语
  photoUrl = "";
  paramList: Param[] = [new Param()];
  showName = "";
  phone = "";
  email = "";
  aiProcessStatus = 0; //ai打分进度
  bgCheckResult = new BG();
  companyId = 0;
  testExamResultData = new MindResult();
  auditStatusAi = 0; //AI评估的初始值
  auditDescAi = "";
  auditTimeAi = "";
  auditTime = "";
  attachmentUrl = ""; // 简历链接
  examId = 0;
  submitTime = ""; //交卷时间
  aiRecommendStatus = 0; //ai推荐级别
  errorInfoList: ErrorInfo[] = [new ErrorInfo()]; //异常
  tags: string[] = [""];
  tagsInvite: string[] = [""];
  tagsRule: string[] = [""];
  tagsAudit: string[] = [""];
  scoreHrTotal = 0; //招行hr 手写总分（印象分）
  scoreAi = 0; //ai打分
  submitStatus = 0; //交卷状态
  submitType = ""; // 交卷方式文本 防切/截屏需求新增
  needEncode = false; //面试是否开启加密报告
  shareHost = ""; //报告页分享ip
  shareSid = ""; //分享解密版秘钥
  isAutoSubmit = 0; //是否自动交卷 1是
  replaceCheckResult = new ReplaceCheckResult(); //换人检测结果；
  faceDetectionResult = new FaceDetectionResult(); //露脸检测结果；
  auditMember = "";
  needCv = 0; //有无工单
  hideCandidateAllInfo = false;

  // 结果页相关
  resultData = "";

  static get(params: any, url = "aiExam/auditPublic/connect") {
    return request.post(url, params).then(resp => {
      const t = new Candidate(resp).assign(resp.data.data);
      t.auditText = auditTextEnum[t.auditStatus];
      return t;
    });
  }
}

//成绩
export class CandidateReport extends Model {
  score = 0; //得分
  scoreExam = 0; //试卷总分
  scoreIndex = 0; //个人排名
  submitCount = 0; //总人数
  beginTime = ""; // 开始时间
  submitTime = ""; // 交卷时间
  useTimeSecond = 0; // 用时
}
//AI维度
export class AI extends Model {
  dimension = "";
  dimensionDesc = ""; //维度描述
  afterHrChange = 0; //维度是否被hr修改过
  reportDescription = ""; //维度评语
  score = 0; //hr打分
  hasNormData = 0; //是否有常模
  dimensionWeight = 0; //权重 1是100%  在维度组外表示占整场面试权重 在维度组list内表示占维度组内权重
  unanswered = 0; //未作答 1是

  //普通AI评分规则下
  scoreAi = 0; //ai打分
  scoreAll = 0; //总分
  scoreAiPercent = 0; //ai超越多少 点的位置
  examMinAiScore = 0; //本场维度最低分
  examMaxAiScore = 0; //本场维度最高分

  //常模评分规则下（新版打分）
  scoreAiV2 = 0; //得分
  scoreAllV2 = 0; //总分
  examV2minAiScore = 0; //本场内最低分（面试内 任一维度没有常模时，按本场范围展示）
  examV2maxAiScore = 0; //本场内最高分
  sceneMinAiScore = -1; //常模内最低分（面试内 所有维度均有常模时，按常模范围展示）
  sceneMaxAiScore = -1; //常模内最高分
  dimensionNormPercent = 0; //常模超过了 percent% 的人 点的位置  【常模和非常模 都使用此字段】
  dimensionLevel = 0; //维度评级  0未评级 10差 20中 30优；
  dimensionLevelDesc = ""; //维度评级描述

  questionList: number[] = []; //冗余？
  //前端冗余
  showMoreDimLimit = 5; //显示更多维度用
}
export class AsrItem extends Model {
  bg = 0;
  ed = 0;
  txt = "";

  highLight = false;
}

export class AsrItemGroup extends Model {
  asrList: AsrItem[] = [];
  isAskAppend = false; // 是否追问回答
  text = ""; // 追问问题文案

  public objectArrayClasses() {
    return {
      asrList: AsrItem
    };
  }
}

export class LocationQuestionAnswer extends Model {
  choiceQuestionAnswer = "";
  distanceDriving = 0;
  distanceTransit = 0;
  locationLat = "";
  locationLng = "";
  locationName = "";
  timeDriving = 0;
  timeTransit = 0;
}
export class ColorOption extends Model {
  content = "";
  isRight = 0;
  key = "";
  keyScore = 0;
}
export class ColorAnswer extends Model {
  colorQuestionId = 0;
  isAnswered = 0;
  isRight = false;
  key = "";
  //新
  imgUrl = "";
  optionList: ColorOption[] = [new ColorOption()]; //选项
  type = 0; // 0:旧版 1:色盲 2:色弱

  // 前端
  get rightAnswerKey() {
    return this.optionList.find(item => item.isRight === 1)?.key || "";
  }
}
export class ColorQuestionAnswerResult extends Model {
  rightNumber = 0;
  colorAnswerList: ColorAnswer[] = [new ColorAnswer()];
  //新版色盲字段
  blindnessResult = 0;
  weaknessResult = 0;
  type = 0; //0是旧版 1是专家版 2是专家版v2   对应业务 1.0 1.1 1.2
  showAnswerDetail = false;
  showErrResMessage = false;
}
export class ImgInfo extends Model {
  imgUrl = "";
  result = 0;
}
export class BodyCheckAnswer extends Model {
  faceResult = 0;
  result = 0;
  imgList: ImgInfo[] = [new ImgInfo()];
}
export class XL extends Model {
  key = "";
}
export class MindInfo extends Model {
  answerDesc = "";
  level = 0;
  questionDesc = "";
  isAnswered = 0;
}
export class PPP extends Model {
  answerDesc = "";
  isAnswered = 0;
  key = "";
  level = 0;
  psychologicalQuestionId = 0;
  questionDesc = "";
}

export class PP extends Model {
  name = "";
  resText = "";
  resultStatus = 0;
  score = 0;
  scoreAll = 0;
  subAnswerList: PPP[] = [new PPP()];
}
export class R extends Model {
  depressiveScore = 0;
  depressiveScoreAll = 0;
  questionAnswerCount = 0;
  questionCount = 0;
  violentScore = 0;
  violentScoreAll = 0;
  psycDimensionList: PP[] = [new PP()]; //普工心理题
  psychologicalAnswerList: MindInfo[] = [new MindInfo()];
  ydgdCdScore = 0;
  ydgdCdScoreAll = 0;
  ydgdJsbScore = 0;
  ydgdJsbScoreAll = 0;
  ydgdShScore = 0;
  ydgdShScoreAll = 0;
}

export class ResultX extends Model {
  content = "";
  dimensionName = "";
  dimensionScore = 0; //浮点数
}
//
export class NewResultXSon extends Model {
  content = ""; //描述
  contentShort = "";
  dimensionName = ""; //维度名
  isMatch = 0; //是否符合
  score = 0;
}
export class NewResultX extends Model {
  content = ""; //描述
  contentShort = "";
  dimensionName = ""; //维度名
  isMatch = 0; //是否符合
  score = 0;
  children: NewResultXSon[] = [new NewResultXSon()];
}
//标准心理题
export class PsycResult extends Model {
  isFinish = 0;
  resultList: ResultX[] = [new ResultX()];
  newResultList: NewResultX[] = [new NewResultX()]; //新报告页 二级结构
  newResultContent = ""; //总结果
  psycGaugeId = 0; //量表id 1大五 3DISC
}
//打气球 个人
export class Ball extends Model {
  cognitiveAbilityContent = ""; //认知
  cognitiveAbilityScore = 0;
  jumpTimes = 0;
  riskAppetiteContent = ""; //风险
  riskAppetiteType = "";
  score = 0;
  timeDurationSecond = 0; //游戏时长
}
export class BallAll extends Model {
  jumpTimes = 0;
  score = 0;
  timeDurationSecond = 0;
}
//西蒙斯 个人
export class SimonsData extends Model {
  content = ""; //综合文案
  depressiveResult = 0;
  depressiveResultStr = "";
  violentResult = 0;
  violentResultStr = "";
  errorNumber = 0;
  timeDurationSecond = 0;
}
export class GlobalSimonsData extends Model {
  depressiveResultStr = "";
  violentResultStr = "";
  errorNumber = 0;
  timeDurationSecond = 0;
}
//小游戏  打气球 西蒙斯
export class GameTestAnswerResult extends Model {
  score = 0;
  scoreAll = 0;
  balloonData = new Ball();
  gameIsFinish = 0; //1完成
  gameTestType = 0; //1 打气球； 2 西蒙斯
  // balloonData = new Ball();
  globalBalloonData = new BallAll();
  simonsData = new SimonsData();
  globalSimonsData = new GlobalSimonsData();
}
//回答小维度的得分情况
export class Dimension extends Model {
  dimensionName = ""; //维度名
  dimensionKey = ""; //维度key
  featureName = "";
  scoreAi = 0;
  scoreAll = 0; //总分
  scoreHr = 0;
  scoreDefault = 0; //上次打分 用于判断hr是否修改了分值
  featureNameList: string[] = [""]; //这两个list是后端用的 原样回传即可
  scoreAllList: number[] = [0];
}
export class QuestionTag extends Model {
  hrResult = 0;
  aiResult = 0;
  tagKey = "";
  tagName = "";
}
export class FingerCheckResult extends Model {
  resultFlexible = 0; // 灵活度结果 0未按要求拍摄 1通过 2有异常 255考察项未配置
  resultFlexibleL = 0; // 灵活度结果
  resultFlexibleR = 0; // 灵活度结果
  resultComplete = 0; // 完整度结果
  resultCompleteL = 0; // 完整度结果
  resultCompleteR = 0; // 完整度结果
  resultScar = 0; // 疤痕结果
  resultScarL = 0; // 疤痕结果
  resultScarR = 0; // 疤痕结果
  resultArmHide = 0; // 手臂遮挡结果
  resultArmHideL = 0;
  resultArmHideR = 0;
  resultArmComplete = 0; // 手臂完整度
  resultArmCompleteL = 0;
  resultArmCompleteR = 0;
  images: string[] = [""]; // 图片列表
}
//追问视频
export class AppendVideo extends Model {
  appendQuestionText = ""; // 追问内容
  videoId = ""; // 追问视频id
  videoUrl = ""; // 追问视频地址
  asr = ""; //追问asr
  asrList: AsrItem[] = [new AsrItem()]; // 追问分段asr
}

export class Answer extends Model {
  aiProcessStatus = 0; //ai打分状态
  aliyunVideoId = "";
  aliyunVideoUrl = "";
  asr = "";
  asrList: AsrItem[] = [];
  asrListAskAppend: AsrItemGroup[] = [];
  asrStatus = 0;
  blanks = [""];
  blanksIsRight = [false];
  content = "";
  imageUrls = [""];
  isAnswered = 0;
  keys = [""];
  choiceIsRight = [false];
  locationQuestionAnswer = new LocationQuestionAnswer();
  questionId = 0;
  score = 0; //手打分
  scoreAi = 0; //系统打分
  scoreStatus = 0;
  scoreHr: any; //hr手动改分  number 或 undefined
  isScored = 0; //已打分 后台综合出来的结果 包括ai和hr双方结果 前端在此基础上 根据业务特殊需要 做判断和修改。
  showMarkTip = false; //提示尚未打分
  colorQuestionAnswerResult = new ColorQuestionAnswerResult(); //色盲检测
  testResult = 0; //测试结果
  testResultAi = 0;
  isManualJudge = 0; //hr是否改过分值
  bodyCheckAnswer = new BodyCheckAnswer();
  psychologicalQuestionAnswer: XL[] = [new XL()];
  psychologicalQuestionAnswerResult = new R();
  type = 0;
  psycResult = new PsycResult(); //标准心理题 （只有富士康是定制的）
  gameTestAnswerResult = new GameTestAnswerResult(); //小游戏
  dimensionAnswerList: Dimension[] = [new Dimension()]; //小维度打分
  questionTagList: QuestionTag[] = [new QuestionTag()]; //疑似念稿
  fingerCheckResult = new FingerCheckResult(); //手指检测
  recommendDesc = ""; //作答情况描述文案
  aiComment = ""; // ai评价
  videoAppendAnswerList: AppendVideo[] = [new AppendVideo()]; //视频追问答案列表
  tacPsycResult = new TacPsyc(); //标准心理题 （只有富士康是定制的）

  public objectArrayClasses() {
    return {
      asrListAskAppend: AsrItemGroup,
      asrList: AsrItem
    };
  }
}
export class Company extends Model {
  name = "";
  logoUrl = "";
  shortname = "";
  companyIcon = "";
}
export class CompanySpecialConfig extends Model {
  auditDescMust = 0; // 是否评价详情必填
  auditRepeat = 0; // 是否允许重复阅卷
  auditUndetermined = 0; // 是否允许阅卷待定
  isEnableAi = 0; //是否开启AI
  vipLevel = 0; // vip等级 0免费 10付费
}
export class Exam extends Model {
  name = "";
  examId = 0;
  remark = "";
  company = new Company();
  companySpecialConfig = new CompanySpecialConfig();
  companyId = 0;
  colorTest = 2;
  fingerTest = 2;
  hideAiScore = false;
  isMarkDimensionScoreExam = 0; //是否开启小维度打分（需同时打开公司配置）
  isHrScore = 0; //是否开启hr手打总分 1开
  examType = ""; //test为fsk通用模式
  bgCheckProductId = 0; //0 关闭// 2 身份识别+社会安全// 3 身份识别+金融// 4 身份识别+社会安全+金融 (身份识别默认选择 不作展示)
  openAiComment = 0; // 是否开启AI评价
  showAllDimension = 2; //报告页是否展示0分的维度 默认否
  encodeTypeConnectCode = 0; //是否展示候选人code；
  positionName = ""; // 岗位名称
}
export class DimensionReportMessage extends Model {
  message = "";
  messageType = 0;
  // EnumDimensionReportMessageType = 1 // 优点
  // EnumDimensionReportMessageType = 2 // 缺点
  // EnumDimensionReportMessageType = 3 // 建议
  // EnumDimensionReportMessageType = 4 // 中性
}
export class LivenessRecognitionResult extends Model {
  idNumber = "";
  age = "";
  isPass = 0;
  isTested = false; //是否已提交
  imgUrl = "";
  errMsg = ""; // 人脸识别结果（失败原因-对外），在报告页展示（V4.0和 V5.0）
}
export class DimensionReportNew extends Model {
  dimension = "";
  score = 0;
  scoreAll = 0;
  medianScore = 0;
  medianScoreDiff = 0;
}
//中位数
export class MiddleInfo extends Model {
  candidateCount = 0;
  candidateIndex = 0;
  dimensionReportNew: DimensionReportNew[] = [new DimensionReportNew()];
}
export class ScoreMap extends Model {
  totalScore = 0;
  scoreAll = 0;
}
export class ScoreMapMap extends Model {
  "1" = new ScoreMap();
  "6" = new ScoreMap();
}
export class QA extends Model {
  question = new Question();
  answer = new Answer();
}
// export enum EnumQuestionType {
//   EnumQuestionTypeSingleChoice = 1, // 单选
//   EnumQuestionTypeMultipleChoice = 2, // 多选 隐藏
//   EnumQuestionTypeJudge = 3, // 判断 被单选代替
//   EnumQuestionTypeQA = 4, // 问答 隐藏
//   EnumQuestionTypeBlanks = 5, // 填空 配置
//   EnumQuestionTypeVideo = 6, // 视频问答
//   EnumQuestionTypeNewSingleChoice = 7, // 测评单选 类单选
//   EnumQuestionTypeMP3 = 8, // 音频题
//   EnumQuestionTypeLocation = 101, // 通勤时间 配置+测评单选
//   EnumQuestionTypeColor = 102, // 颜色识别 测评类型
//   EnumQuestionTypeVideoSquat = 103, // 蹲起检测 类视频问答 测评类型
//   EnumQuestionTypeVideoBody = 104, // 形体检测 类视频问答 测评类型
//   EnumQuestionTypePsychological = 105, // fsk心理检测 子选择题列表 测评类型
//   EnumQuestionTypePsyc = 106, // 通用心理检测 子选择题列表 测评类型 报告类型
//   EnumQuestionTypeGame = 107 // 通用游戏测评 测评类型 报告类型
// }
export class QuestionAnswerMap extends Model {
  1: QA[] = [new QA()]; //单选
  2: QA[] = [new QA()]; //多选
  3: QA[] = [new QA()]; //判断
  4: QA[] = [new QA()]; //问答
  5: QA[] = [new QA()]; //填空
  6: QA[] = [new QA()]; //视频问答
  7: QA[] = [new QA()]; //测评单选
  8: QA[] = [new QA()]; //音频题
  101: QA[] = [new QA()]; //通勤时间
  102: QA[] = [new QA()]; //颜色识别
  103: QA[] = [new QA()]; //
  104: QA[] = [new QA()];
  105: QA[] = [new QA()];
  106: QA[] = [new QA()];
  110: QA[] = [new QA()];
  107: QA[] = [new QA()];
  108: QA[] = [new QA()]; //手臂检测
  109: QA[] = [new QA()]; //手部综合检测
}
export class ScoreJudge extends Model {
  list = [""]; // 当前项目得分 空串表示未评分
  avg = ""; // 平均分 至少存在1条有效记录
  avg2 = ""; // 去极值平均分 至少存在3条有效记录
  min = "";
  max = "";
}
export class DimensionAnswer extends Model {
  dimensionName = ""; // 维度名
  scoreHr = new ScoreJudge(); // 面试官打分
}
export class QuestionScore extends Model {
  questionId = 0; // 题目id
  score = new ScoreJudge(); // 打分
  dimensionAnswerList = [new DimensionAnswer()];
  judgeNameList = [""]; // 面试官名列表
}
//多人面试结果
export class JudgeResult extends Model {
  canUseAvgScoreByQuestion = false;
  canUseAvgScoreByDimension = false;
  canUseAvg2scoreByQuestion = false;
  canUseAvg2scoreByDimension = false;
  judgeNameList = [""]; // 面试官名列表
  auditStatusList = [0]; // 评估结果列表 0123
  tagsList = [[""]]; // 标签列表
  scoreJudge = new ScoreJudge(); // 总分列表
  questionScoreList = [new QuestionScore()]; //题目分数列表
}

class AIComent extends Model {
  advantageArray: string[] = [""];
  aiKeyElementTextBad: string[] = [""];
  aiKeyElementTextGood: string[] = [""];
  disadvantageArray: string[] = [""];
  aiComment = "";
  nextQuestion = "";
  nextSuggest = "";
}
export class AIGroup extends Model {
  dimension = "";
  dimensionKey = "";
  dimensionIconUrl = ""; //组图标
  dimensionDesc = "";
  dimensionLevel = 0; //维度评级  0未评级 10差 20中 30优;
  dimensionLevelDesc = ""; //维度评级文案
  dimensionList: AI[] = [new AI()];
  dimensionNormPercent = 0; //常模超过了 percent% 的人 点的位置
  hasNormData = 0; //是否有常模
  unanswered = 0; //未作答 1是
  transformScore = 0; //转换后的组得分；整数
  starLevel = 0; //评分星级 0 - 10

  aiKeyElementTextBad: string[] = [""];
  aiKeyElementTextGood: string[] = [""];

  showChart = 0; // 是否显示图表 1开
  showComport = 0; // 是否显示行为表现
  showEvaluate = 0; // 是否显示评价
  readingGuidelinesType = 0; // 附录，各维度说明的文案显示判断
  readingGuidelinesMessage = ""; // 展示结果说明文案 当 readingGuidelinesType==4 时 非空

  showAllDim = false; //是否展示全部维度 前端冗余
}
class CandidateCount extends Model {
  allSameSubmit = 0; //等于候选人得分的人数
  allLowerSubmit = 0; //小于候选人得分的人数
  allSubmit = 0;
  percent = 0; //超越了百分之多少的人
}

class ConfigGroup extends Model {
  configName = ""; // 配置名称
  reportVersion = 0; // 报告版本 4
  showType = 0; // 展示方式  0 = 维度 1 = 维度组
  showReferenceAnswer = 0; // 是否展示参考答案
  scoreType = 0; // 展示方式  0 = 维度 1 = 维度组
  suggestType = 0; // 面试建议类型 0 不展示 1非模考 2模考
  needReadingGuidelines = 0; // 是否需要阅读指引
}
class ReportShowConfig extends Model {
  hiddenTotalScore = 0; // 是否隐藏总分数  012 1隐藏   （旧版用 右上角整体隐藏）
  hiddenTotalScoreNew = 0; // 是否隐藏总分数
  hiddenAiRecommend = 0; // 是否隐藏AI推荐
  hiddenCandidateIndex = 0; // 是否隐藏候选人同职位竞争力排序

  hiddenOverview = 0; // 是否隐藏AI面试总览
  hiddenOverviewPieChart = 0; // 是否隐藏AI面试总览-饼状图
  hiddenOverviewDimensionGroupIcon = 0; // 是否隐藏AI面试总览-维度组ICON
  hiddenOverviewAiComment = 0; // 是否隐藏AI面试总览-AI评价
  hiddenOverviewNextSuggest = 0; // 是否隐藏AI面试总览-下一轮面试建议

  hiddenDimensionAnalyze = 0; // 是否隐藏维度分析
  hiddenDimensionChart = 0; // 是否隐藏 非维度组 图表  这三项 维度组时 读取组配置
  hiddenDimensionComport = 0; // 是否隐藏 非维度组 行为表现
  hiddenDimensionEvaluate = 0; // 是否隐藏 非维度组 评价

  hiddenPsyc = 0; // 是否隐藏心理测评

  hiddenCandidateAnswer = 0; // 是否隐藏回答记录
  hiddenCandidateAnswerAiComment = 0; // 是否隐藏回答记录中的AI评价
  hiddenErrorInfo = 0; // 是否隐藏异常信息
  hiddenOtherInfo = 0; // 是否隐藏 其他信息 模块
  topParamShowAll = 0; // 顶部登记信息是否展示全部字段  0上下分开  1展示全部

  englishAssessmentShowType = 0; //英语测评展示样式 0-雅思成绩单样式 1-9级柱状图样式
  hiddenSubmitDuration = 0; //是否隐藏面试总时长
  showDimensionGroupAiComment = 0; //是否展示维度组的组内总评价
  hiddenDimensionTotalComment = 0; //是否展示维度总评价
  onlyShowAiTag = 0; //是否只展示AI评价标签 并修改标题

  hiddenIseChineseScorePercent = 0; // EnumBoolOption 是否隐藏普通话百分位分值
  iseChineseScorePercentLimit1 = 0; // int  报告页普通话分数线1
  iseChineseScorePercentLimit2 = 0; // 报告页普通话分数线2

  hiddenDimensionGroupStar = 0; // 是否隐藏维度组星级
  //报告页头部总评价 相关开关
  hiddenOverviewHrComment = 0; // 是否隐藏AI面试总览-HR评价  -> 报告页是否隐藏面试官评价
  hiddenHrScore = 0; // 报告页是否隐藏面试官打分
  hiddenAuditStatus = 0; // 报告页是否隐藏评估结果
  showAutoAuditScore = 0; // 自动阅卷时报告页是否展示面试官打分  这三项自动阅卷优先级低于hr阅卷
  showAutoAuditStatus = 0; // 自动阅卷时报告页是否展示评估结果
  showAutoAuditDesc = 0; // 自动阅卷时报告页是否展示面试官评价
  hiddenAiDimensionPercent = 0; // 是否隐藏AI维度分析权重列

  hiddenBlankDetail = 0; // 是否隐藏填空题填空内容正确或错误结果，0-不隐藏 1-隐藏（V4.0 报告页使用）
  hiddenDownloadButton = 0; // 是否隐藏下载按钮，0-不隐藏 1-隐藏（V4.0 报告页使用）
  hiddenShareButton = 0; // 是否隐藏导出链接按钮，0-不隐藏 1-隐藏（V4.0 报告页使用）
}
export class OptionMap extends Model {
  public getAllDataFormServer() {
    return "optionMap";
  }
  // hiddenCompanyNameLogo = false; // 是否隐藏公司名称和logo 7-11版本干掉
  hiddenCompanyLogo = false; // 是否隐藏公司logo
  hiddenCompanyName = false; // 是否隐藏公司名称
  hiddenPositionName = false; // 是否隐藏岗位名称
  hiddenNormalTag = false; // 基本信息-是否隐藏正常标签
  hiddenHrScore = false; // 基本信息-是否隐藏面试官打分
  hiddenAiComment = false; // 是否隐藏AI评价
  hiddenAuditStatus = false; // 是否隐藏评估结果
  hiddenReferenceAnswerAudio = true; //是否隐藏参考答案 音频题
  hiddenReferenceAnswerBlank = true; //是否隐藏参考答案 填空
  hiddenReferenceAnswerChoice = true; //是否隐藏参考答案 选择
  hiddenReferenceAnswerVideo = true; //是否隐藏参考答案 视频题
  EX = true; //测试取值用
}
export class ReportShowConfigV5Item extends Model {
  name = ""; //模块名称
  versionId = 0; //选择的版本id
  isHidden = false; //是否隐藏
  sort = -1; //排序
  optionMap = new OptionMap(); //配置项
}

//候选人成绩与AI结果
export class CandidateResult extends Model {
  answerList: Answer[] = [new Answer()];
  candidateReport = new CandidateReport();
  configGroup = new ConfigGroup();
  dimensionReport: AI[] = [new AI()];
  dimensionReportGroup: AIGroup[] = [new AIGroup()]; //维度分组展示
  dimensionReportMessage: DimensionReportMessage[] = [
    new DimensionReportMessage()
  ];
  questionList: Question[] = [new Question()];
  livenessRecognitionResult = new LivenessRecognitionResult(); //身份认证
  exam = new Exam();
  questionNumber = 0;
  scoreAll = 0;
  scoreMap = new ScoreMapMap();
  headerDataList: any = []; //fsk 三大关注项
  questionAnswerMap = new QuestionAnswerMap(); //题目答案 map结构
  coderDetail: any; //笔面试数据
  scoreHrTotal = 0; //hr手打总分（招行用）
  judgeResult = new JudgeResult();
  errorInfoList: ErrorInfo[] = [new ErrorInfo()]; //异常 0缺数据 1异常 2正常
  hasDimensionReportMessageConfig = false; //表示维度描述性评价的配置是否存在
  aiComment = new AIComent();
  candidateCount = new CandidateCount();
  webJumpCheck = 0; //web切屏是否开启  1开启
  webJumpImgUrlList: string[] = [""]; // 切屏图片  有length则是存在切屏

  needReadingGuidelines = 0; // 是否需要阅读指引 0-不需要 1-需要
  readingGuidelinesType = 0; // 维度组维度指引类型 0基础维度 1通用素质 2岗位匹配度 3职业规划 4进阶能力 255其他维度
  readingGuidelinesMessage = 0; // 展示结果说明文案 当 readingGuidelinesType==4 时 非空
  unanswered = 0; // 是否未作答
  hasNormData = 0; // 是否是常模维度组
  reportShowConfig = new ReportShowConfig(); // 结构化报告展示配置
  reportShowConfigV5: ReportShowConfigV5Item[] = [new ReportShowConfigV5Item()]; // 结构化报告展示配置 v5
  extraResultList: ExtraResult[] = [new ExtraResult()]; //自定义页结果
  englishAssessmentResult = new EnglishAssessmentResult(); //英语水平
  chineseAssessmentResult = new ChineseAssessmentResult(); //普通话水平

  static get(params: any, url = "aiExam/auditPublic/questionAnswers") {
    return request.post(url, params).then(resp => {
      const t = new CandidateResult(resp).assign(resp.data.data);
      t.answerList.forEach((d: Answer) => {
        d.scoreHr = d.score; //hr手动改分字段
        d.dimensionAnswerList.forEach((m: Dimension) => {
          m.scoreDefault = m.scoreHr; //hr手动改分的小维度
        });
      });
      t.headerDataList = resp?.data?.data?.headerDataList; //工单
      t.coderDetail = resp?.data?.data?.coderDetail; //笔面试数据
      //AI评价
      if (resp?.data?.data?.aiComment)
        t.aiComment = resp?.data?.data?.aiComment;
      if (t.aiComment) {
        t.aiComment.advantageArray = t.aiComment?.advantageArray.filter(
          (item: string) => item !== ""
        );
        t.aiComment.disadvantageArray = t.aiComment?.disadvantageArray.filter(
          (item: string) => item !== ""
        );
        t.aiComment.aiKeyElementTextBad = t.aiComment?.aiKeyElementTextBad.filter(
          (item: string) => item !== ""
        );
        t.aiComment.aiKeyElementTextGood = t.aiComment?.aiKeyElementTextGood.filter(
          (item: string) => item !== ""
        );
      }
      // t.aiComment.advantageArray = ["测试测试测试测试测试测试","aaa","bbb"]
      // t.aiComment.disadvantageArray = ["测试测试测试测试测试测试","aaa","bbb"]
      return t;
    });
  }
  //中位数
  static getMiddle(params: any, url = "aiExam/auditPublic/detailInfo") {
    return request.post(url, params).then(resp => {
      const t = new MiddleInfo(resp).assign(resp.data.data.detailInfo);
      return t;
    });
  }
  //富士康 cvData 工单相关 等
  static getFSK(params: any, url = "aiExam/fskPublic/getAll") {
    return request.post(url, params).then(resp => {
      return resp;
    });
  }
  //获取候选人码所属公司id 和examType
  static getCid(connectCode: number, tid?: string) {
    return request
      .post("/aiExam/auditPublic/version", {
        connectCode: connectCode,
        tid: tid
      })
      .then(resp => {
        if (resp.data.code === 0) {
          return new Ver().assign(resp.data.data);
        } else {
          return new Ver();
        }
      });
  }

  // 根据 ticket 获取报告信息，ticket 每个只能用一次
  static getAuditPublicTicket(ticket: string) {
    return request.post("/aiExam/auditPublic/ticket", { ticket }).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }

  // 仅仅测试环境使用的报告参数获取接口
  static tempReport(companyId: number, outId: string) {
    return request
      .post("/aiExam/openApi/candidateGetReport", { companyId, outId })
      .then(resp => {
        if (resp.data.code === 0) {
          return resp.data.data;
        }
      });
  }
}
